import { useEffect, useState } from "react";
import api from "../lib/api";

export function usePatientEducationLanguage(pid) {
  const [scope, setScope] = useState({ pid: undefined, patient: null, error: "" });
  const [lang, setLang] = useState("mr");
  useEffect(() => {
    let active = true;
    setScope({ pid: undefined, patient: null, error: "" });
    setLang("mr");
    if (!pid) { setScope({ pid, patient: null, error: "" }); return; }
    api.get(`/patients/${pid}`).then(({ data }) => {
      if (!active) return;
      setLang(data.patient.preferred_language || "mr");
      setScope({ pid, patient: data.patient, error: "" });
    }).catch(() => {
      if (active) setScope({ pid, patient: null, error: "Could not load the patient language. Reopen Education from the patient record." });
    });
    return () => { active = false; };
  }, [pid]);
  return { lang, setLang, patient: scope.pid === pid ? scope.patient : null,
    ready: scope.pid === pid && !scope.error, error: scope.error };
}